export class UpdateImageCompressionSettingsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UpdateImageCompressionSettingsError";
  }
}
